import $ from 'jquery';

(function () {

	var initGalleryBlock = function(galleryContainerSelector) {

		$(galleryContainerSelector).each(function(i, container) {

			var containerElement = $(this);
			var flickityElement = containerElement.find('.block-product-detail-slider__carousel-main')[0];
        
	        // display each gallery item's corresponding content text
	        var flkty = Flickity.data(flickityElement);

	        flkty.on( 'change', function( index ) {
	        	containerElement.parent().find('.block-gallery__item-content-container').hide();
	        	containerElement.parent().find('.block-gallery__content-container').children().eq(index).fadeIn();
			});
		});
	};

	$( document ).ready(function() {

		// execute above function
		if (document.getElementsByClassName('block-gallery__carousel-container').length) {
			initGalleryBlock('.block-gallery__carousel-container');
		}

	});

}());



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/blocks/gallery/index.js